import WorkCard from './workCard';

export default WorkCard;